export default __webpack_public_path__ + "static/media/NB_bank.439a8fd5.jpg";